/**
 * アバター画像マップ
 * アバター名・性別年齢層に基づいて画像を解決する
 */

import { Avatar } from "../types";

// アバター画像を動的にimport
import 田中賢人 from "../assets/images/田中賢人.png";
import 佐藤有沙 from "../assets/images/佐藤有沙.png";
import 鈴木大輔 from "../assets/images/鈴木大輔.png";
import 田中梨花 from "../assets/images/田中梨花.png";
import 高橋健 from "../assets/images/高橋健.png";
import 伊藤真由 from "../assets/images/伊藤真由.png";
import 渡辺亮 from "../assets/images/渡辺亮.png";
import 中村優香 from "../assets/images/中村優香.png";
import 小林智也 from "../assets/images/小林智也.png";
import 斎藤恵理 from "../assets/images/斎藤恵理.png";
import 木村翔 from "../assets/images/木村翔.png";
import 石井優 from "../assets/images/石井優.png";
import 清水翔子 from "../assets/images/清水翔子.png";
import 松本太 from "../assets/images/松本太.png";
import 原田真一 from "../assets/images/原田真一.png";
import 大野彩 from "../assets/images/大野彩.png";
import 山田花子 from "../assets/images/山田花子.png";
import 黒田真理 from "../assets/images/黒田真理.png";
import 長谷川勇 from "../assets/images/長谷川勇.png";
import 青木誠 from "../assets/images/青木誠.png";
import 木村隼人 from "../assets/images/木村隼人.png";
// 性別・年齢層別の画像
import M1 from "../assets/images/M1.png";
import M2 from "../assets/images/M2.png";
import M3 from "../assets/images/M3.png";
import F1 from "../assets/images/F1.png";
import F2 from "../assets/images/F2.png";
import F3 from "../assets/images/F3.png";

const conditionImageMap: { [key: string]: any } = {
  'M1.png': M1,
  'M2.png': M2,
  'M3.png': M3,
  'F1.png': F1,
  'F2.png': F2,
  'F3.png': F3,
};

const nameImageMap: { [key: string]: any } = {
  '田中賢人': 田中賢人,
  '佐藤有沙': 佐藤有沙,
  '鈴木大輔': 鈴木大輔,
  '田中梨花': 田中梨花,
  '高橋健': 高橋健,
  '伊藤真由': 伊藤真由,
  '渡辺亮': 渡辺亮,
  '中村優香': 中村優香,
  '小林智也': 小林智也,
  '斎藤恵理': 斎藤恵理,
  '木村翔': 木村翔,
  '石井優': 石井優,
  '清水翔子': 清水翔子,
  '松本太': 松本太,
  '原田真一': 原田真一,
  '大野彩': 大野彩,
  '山田花子': 山田花子,
  '黒田真理': 黒田真理,
  '長谷川勇': 長谷川勇,
  '青木誠': 青木誠,
  '木村隼人': 木村隼人,
};

export function getAvatarImage(avatar: Avatar): any {
  if (avatar.videoFiles?.image) {
    const imageFilePath = avatar.videoFiles.image.replace('/videos/', '');
    const imageFileName = imageFilePath.split('/').pop() || imageFilePath;
    if (conditionImageMap[imageFileName]) {
      return conditionImageMap[imageFileName];
    }
    return avatar.videoFiles.image;
  }

  // 歯科医アバターの場合
  if (avatar.type === 'dentist') {
    return '/videos/assets/dentists/female_default/base/avatar.jpg';
  }

  // フォールバック: アバター名に基づいて画像を取得
  return nameImageMap[avatar.name] || 田中賢人;
}
